import { render } from "./UiTextbaustein.pug?vue&type=template&id=724bddd4&lang=pug"
import script from "./UiTextbaustein.js?vue&type=script&lang=js"
export * from "./UiTextbaustein.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__